import {makeAutoObservable} from 'mobx';
import {AIRepository} from '../../../../data/repositories/AiRepository';
import LoadingModule from '../../../../modules/LoadingModule/LoadingModule';
import GradebookRepository from '../../../../data/repositories/GradebookRepository';
import {toast} from 'react-toastify';
import {getErrorFromCode} from '../../../../data/errorCodes';
import {toastConfig} from '../../../../uiToolkit/Toast/toastConfig';

class CourseLevelAnalyticsRootStore {
  private aiRepository = new AIRepository();
  private gradebookRepository = new GradebookRepository();
  private loadingModule = new LoadingModule();

  constructor() {
    makeAutoObservable(this);
  }

  public async getCoursesList(organizationId: string, search: string) {
    this.loadingModule.startLoading();
    const result = await this.aiRepository.fetchCoursesShortList(
      organizationId,
      search,
    );
    this.loadingModule.endLoading();
    if (result.success && result.data) {
      return result.data;
    }
    return [];
  }

  public async getCourseAnalytics(organizationId: string, courseId: string) {
    this.loadingModule.startLoading();
    const result = await this.gradebookRepository.getCourseAnalytics(
      organizationId,
      courseId,
    );
    if (result.success && result.data) {
      return result.data;
    } else if (!result.success && result.errors && result.errors.length) {
      toast.error(getErrorFromCode(result.errors[0]), toastConfig);
    }
  }
}

export default CourseLevelAnalyticsRootStore;
